import { Button, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconUserCircle } from '@tabler/icons-react';

/**
 * «Это не я» — выйти из участника, которого запомнил браузер.
 *
 * Браузер теперь помнит гостя между вкладками и перезапусками. Обратная
 * сторона: общий iPad, второй человек за тем же ноутбуком или тест нескольких
 * участников попадают в чужую личность. Кнопка забывает участника только этого
 * приглашения и возвращает форму имени; в сессии прежний участник остаётся, и
 * убрать его может ведущий.
 */
export function SwitchGuestButton({
  displayName,
  onConfirm,
}: {
  displayName: string;
  onConfirm: () => void;
}) {
  return (
    <Button
      size="compact-xs"
      variant="subtle"
      color="gray"
      leftSection={<IconUserCircle size={14} />}
      data-testid="switch-guest"
      onClick={() =>
        modals.openConfirmModal({
          title: 'Войти как другой участник?',
          children: (
            <Text size="sm" c="var(--text-muted)">
              Этот браузер перестанет помнить участника «{displayName}». Вернуться под ним будет
              нельзя: вы войдёте заново под новым именем, а «{displayName}» останется в списке, пока
              его не удалит ведущий.
            </Text>
          ),
          labels: { confirm: 'Войти как другой', cancel: 'Остаться' },
          onConfirm,
        })
      }
    >
      Это не я
    </Button>
  );
}
